import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_time",
  "use": "icon-icon_time-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_time\"><defs><style></style></defs><path d=\"M512 40.96A471.04 471.04 0 1 0 983.04 512 471.04 471.04 0 0 0 512 40.96zm0 890.88A419.84 419.84 0 1 1 931.84 512 420.25 420.25 0 0 1 512 931.84z\" /><path d=\"M535.962 501.76V180.838a25.6 25.6 0 1 0-51.2 0v334.644a25.6 25.6 0 0 0 11.264 20.48L737.28 700.416a25.6 25.6 0 0 0 28.672-42.394z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol